import {LoginDto, SignUpDto, checkDuplicateUserIdDto, NaverLoginDto} from '@/services/LoginModels';
import AXIOS from '@/services/axios-wrapper';
import {User, UserIdFind} from '@/models';
import {
  PMS_Res_HotelForecastList,
  PMS_Res_HotelForecastListItem,
  PMS_Res_PackageRoomTypeList,
  PMS_YYYYMMDD,
} from '@/models-hotel';
import moment from 'moment';
import MyHotelType from '@/pages/Reservation/hotelType';
import {PMSResDto} from '@/models';

export interface HotelForeCastResult {
  hotelForecastList: PMS_Res_HotelForecastListItem[];
  availDates: Date[];
  checkInStartDate: Date; //체크인으로 선택 가능한 첫 날짜
  checkOutEndDate: Date; //체크아웃으로 선택 가능한 마지막 날짜
}

export interface DateRange {
  start: Date;
  end: Date;
}

const MAX_DAYS = 9;

class HotelService {
  checkDayAvail(checkDay: Date | moment.Moment, hotelForecastList: PMS_Res_HotelForecastListItem[]) {
    const checkDayStr = moment(checkDay).format(PMS_YYYYMMDD);
    const found = hotelForecastList.find(x => x.saleDate === checkDayStr && x.janSum > 0);
    console.log('checkDayAvail ', checkDayStr, found);
    return found;
  }

  checkJanSumRange(range: DateRange, hotelForecastList: PMS_Res_HotelForecastListItem[], showErrorMsg: any) {
    // 설정 불가능한 날짜가 끼어있는지 검사한다.
    console.log('checkJanSumRange', range, hotelForecastList);
    const checkDay = moment(range.start);
    const endDay = moment(range.end);
    const firstCheck = endDay.diff(checkDay, 'days') > 0;
    let check = true;
    //console.log(firstCheck, checkDay, endDay);
    while (endDay.diff(checkDay, 'days') > 0) {
      if (!this.checkDayAvail(checkDay, hotelForecastList)) {
        check = false;
        break;
      }
      checkDay.add(1, 'd');
    }

    if (!check || !firstCheck) {
      showErrorMsg('선택할 수 없는 날짜가 포함되어 있습니다.');
      return false;
    }

    return true;
  }

  calcBestFitDateRange(range: DateRange, checkInStart: Date, checkOutEnd: Date): DateRange {
    let newRange: DateRange = {start: range.start, end: range.end};
    //console.log(range);
    const start = moment(range!.start!);
    const end = moment(range!.end!);

    const diffDays = end.diff(start, 'd');

    if (diffDays < 1) {
      const endDayAvail = moment(checkOutEnd);

      // 마지막 날은 endDay로 선택될 수 없어서 시작날짜를 땡긴다
      const diffEndDays = end.diff(endDayAvail, 'days');
      //console.log(diffEndDays);
      if (diffEndDays === 0) {
        start.add(-1, 'd'); //시작날짜를 앞으로 땡긴다
      } else {
        end.add(1, 'd'); // 끝 날짜를 뒤로 민다
      }
      newRange = {
        start: start.toDate(),
        end: end.toDate(),
      };
    } else if (diffDays > MAX_DAYS) {
      //최대 일 수 이상 선택되면 시작날짜 기준 최대 일수로 강제한다.
      newRange = {
        start: start.toDate(),
        end: start.clone().add(MAX_DAYS, 'd').toDate(),
      };
    }

    return newRange;
  }

  async fetchHotelForecastList(memType?: string): Promise<HotelForeCastResult> {
    let forecastType = 'G';

    if (memType) {
      if (
        memType === '001' ||
        memType === '002' ||
        memType === '003' ||
        memType === '004' ||
        memType === '005' ||
        memType === '006' ||
        memType === '007'
      )
        forecastType = 'M';
    }

    const reqResult = await AXIOS.post<PMS_Res_HotelForecastList>('/hotel/HotelForecastList', {
      hotelType: MyHotelType,
      forecastType,
    });
    //console.log(reqResult.data);
    if (reqResult.data.resultCode !== '0000') {
      alert(reqResult.data.msg);
    }

    // hotelForecastList: PMS_Res_HotelForecastListItem[] = [];
    const hotelForecastList = reqResult.data.items;

    hotelForecastList
      .filter(x => x.janSum <= 0)
      .forEach(x => {
        console.log('잔여룸0:', x);
      });

    // WARN : 불가능한 날짜 집어 넣기 TEST
    // 강제로 특정 날짜 예약가능객실 0으로 만드는 테스트
    //hotelForecastList[10].janSum = 0;

    const availDates = hotelForecastList.filter(x => x.janSum > 0).map(x => moment(x.saleDate, PMS_YYYYMMDD).toDate());
    const checkInStartDate = moment(hotelForecastList[0]?.saleDate, PMS_YYYYMMDD).toDate();
    const checkOutEndDate = moment(hotelForecastList[hotelForecastList.length - 1]?.saleDate, PMS_YYYYMMDD)
      .add(1, 'd')
      .toDate();

    return {
      hotelForecastList,
      availDates,
      checkInStartDate,
      checkOutEndDate,
    };
  }
  async isBupinEnable(memNo: string, cntrlDvsn?: string) {
    const apiPath = '/com/CrprsAvlblList';
    if (!cntrlDvsn) cntrlDvsn = '2';
    const data = {cntrlDvsn: cntrlDvsn, memNo: memNo};
    const response = await AXIOS.post<any>(apiPath, data);
    console.log(response.data);
    if (response.data.resultCode === '0000') {
      const useYn = response.data.obj.useYn;
      if (useYn === 'N') return true;
    }

    return false;
  }
  async isReservEnable(cciDate: string) {
    const apiPath = '/hotel/HotalTmrwRsvCheck';
    const data = {cciDate: cciDate};
    const response = await AXIOS.post<any>(apiPath, data);
    console.log(response.data);
    if (response.data.resultCode === '0000') {
      const excessYn = response.data.obj.excessYn;
      if (excessYn === 'Y') return true;
    }
    return false;
  }

  async getHotelAgeList(cciDate: string) {
    const apiPath = '/hotel/HotelAgeList';
    const data = {stDate: cciDate};
    const response = await AXIOS.post<any>(apiPath, data);
    //console.log(response.data);
    if (response.data.resultCode === '0000') {
      return response.data.items;
    }
    return [];
  }
  async fetchHotelRoomForecastList(giftNo: string): Promise<HotelForeCastResult> {
    const forecastType = 'G';

    const reqResult = await AXIOS.post<PMS_Res_HotelForecastList>('/hotel/HotelRoomForecastList', {
      hotelType: MyHotelType,
      forecastType,
      giftNo: giftNo,
    });
    //console.log(reqResult.data);
    if (reqResult.data.resultCode !== '0000') {
      alert(reqResult.data.msg);
    }

    // hotelForecastList: PMS_Res_HotelForecastListItem[] = [];
    const hotelForecastList = reqResult.data.items;

    // hotelForecastList
    //   .filter(x => x.janSum <= 0)
    //   .forEach(x => {
    //     console.log('잔여룸0:', x);
    //   });

    // WARN : 불가능한 날짜 집어 넣기 TEST
    // 강제로 특정 날짜 예약가능객실 0으로 만드는 테스트
    //hotelForecastList[10].janSum = 0;
    // hotelForecastList
    //   .filter(x => x.saleDate === '20230601')
    //   .forEach(x => {
    //     x.janSum = 0;
    //   });

    const availDates = hotelForecastList.filter(x => x.janSum > 0).map(x => moment(x.saleDate, PMS_YYYYMMDD).toDate());
    const checkInStartDate = moment(hotelForecastList[0]?.saleDate, PMS_YYYYMMDD).toDate();
    const checkOutEndDate = moment(hotelForecastList[hotelForecastList.length - 1]?.saleDate, PMS_YYYYMMDD)
      .add(1, 'd')
      .toDate();
    const availDates2: Date[] = [];
    const checkInStartDate2 = moment(hotelForecastList[0]?.saleDate, PMS_YYYYMMDD);
    const checkOutEndDate2 = moment(hotelForecastList[hotelForecastList.length - 1]?.saleDate, PMS_YYYYMMDD).add(
      1,
      'd',
    );
    const diffDays = checkOutEndDate2.diff(checkInStartDate2, 'days');
    for (let i = 0; i <= diffDays + 1; i++) {
      const addDate = checkInStartDate2.clone().add(i, 'd').toDate();
      if (availDates.filter(x => moment(x).format(PMS_YYYYMMDD) === moment(addDate).format(PMS_YYYYMMDD)).length > 0) {
        availDates2.push(addDate);
      }
    }

    return {
      hotelForecastList,
      availDates: availDates2,
      checkInStartDate,
      checkOutEndDate,
    };
  }
  async getAvailPkgRoomList(stDate: string, edDate: string, giftNo: string) {
    const reqResult = await AXIOS.post<PMS_Res_PackageRoomTypeList>('/gift/PackageGiftRoomList', {
      hotelType: MyHotelType,
      stDate,
      edDate,
      giftNo,
    });
    if (reqResult.data.resultCode !== '0000') {
      alert(reqResult.data.msg);
    }
    return reqResult.data.items;
  }
}

// Export a singleton instance in the global namespace
export const hotelService = new HotelService();
